/**
 * Shared Turnstile error constants.
 * Single source of truth for error codes and user-facing messages.
 */

export const TURNSTILE_ERROR_CODES = [
  "TURNSTILE_INVALID",
  "TURNSTILE_COOKIE_MISSING",
  "TURNSTILE_COOKIE_EXPIRED",
] as const;

export type TurnstileErrorCode = (typeof TURNSTILE_ERROR_CODES)[number];

export const TURNSTILE_ERROR_MESSAGE =
  "Nie udało się zweryfikować przeglądarki. Odśwież stronę, wyłącz rozszerzenia blokujące (np. AdBlock, Brave Shields) lub spróbuj otworzyć stronę w innej przeglądarce (Chrome, Firefox, Edge).";

export const TURNSTILE_DOCS_PATH = "/troubleshooting/weryfikacja-przegladarki";

export function isTurnstileErrorCode(code: string): code is TurnstileErrorCode {
  return (TURNSTILE_ERROR_CODES as readonly string[]).includes(code);
}
